"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabletMediaQuery = exports.useMobileMediaQuery = exports.useDesktopMediaQuery = void 0;
const media_constants_1 = require("./media-constants");
const useMediaQuery_1 = require("./useMediaQuery");
function useDesktopMediaQuery() {
    return (0, useMediaQuery_1.useMediaQuery)({
        minWidth: media_constants_1.TABLET_MAX_WIDTH,
    });
}
exports.useDesktopMediaQuery = useDesktopMediaQuery;
function useMobileMediaQuery() {
    return (0, useMediaQuery_1.useMediaQuery)({
        maxWidth: media_constants_1.TABLET_MAX_WIDTH - 1,
    });
}
exports.useMobileMediaQuery = useMobileMediaQuery;
function useTabletMediaQuery() {
    return (0, useMediaQuery_1.useMediaQuery)({
        minWidth: media_constants_1.TABLET_MIN_WIDTH,
        maxWidth: media_constants_1.TABLET_MAX_WIDTH,
    });
}
exports.useTabletMediaQuery = useTabletMediaQuery;
//# sourceMappingURL=index.js.map